import { GameState } from "../models/game";

const API_BASE_URL = "https://api.sysdesignplayground.com";

/**
 * Extracts only the fields needed for the user-designs endpoint
 * from the full game state.
 */
function buildUserDesignPayload(gameState: GameState) {
  return {
    game: {
      nodes: gameState.nodes,
      edges: gameState.edges,
      blocks: gameState.blocks,
      timeElapsedInSec: gameState.timeElapsedInSec,
      trafficPattern: gameState.trafficPattern,
      trafficRoutes: gameState.trafficRoutes,
    },
  };
}

/**
 * Saves a snapshot of the current game state to the user-designs endpoint.
 * Fire-and-forget — errors are logged but do not block gameplay.
 */
export async function saveUserDesign(gameState: GameState): Promise<void> {
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const isGaDisabled = localStorage.getItem("admin_no_track") === "true" || 
                       window.location.search.includes("disable_ga=true") || 
                       window.location.search.includes("ga_disable=true");

  if (isLocalhost || isGaDisabled) {
    return;
  }

  try {
    const payload = buildUserDesignPayload(gameState);

    const response = await fetch(`${API_BASE_URL}/user-designs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.error("Failed to save user design:", response.status, response.statusText);
    }
  } catch (err) {
    console.error("Error saving user design:", err);
  }
}
